<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      :disabled="disabled"
      @reload="reload"
      @checkbox-change="(e) => (checkedRow = e)"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        :checkedCount="checkedCount"
        @query="getData"
        @reset="resetPage({ pageSize: 100 })"
        @mergeShipment="mergeShipment"
        @fallback="$refs.main.batchFallback()"
        @exportFile="exportFile"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <MergeShipment
      :visible.sync="mergeShipmentVisible"
      :title="$l('dialog_title_mergeShipment') || '确认合并发运信息'"
      :data="checkedRow"
      @reload="reload"
      @delete="onMergeShipmentDelete"
    />

    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        custCode: chooseTemplateOptions.custCode,
        endCustCode: chooseTemplateOptions.endCustCode,
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: {
          listShipmentBatchCode: chooseTemplateOptions.listShipmentBatchCode,
        },
      }"
    />
  </div>
</template>

<script>
import PageMain from './main.vue'
import PageHeader from './header.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import MergeShipment from '../merge-shipment'
import ChooseTemplate from '@/views/factory/transport/components/choose-template'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, MergeShipment, ChooseTemplate },
  props: { disabled: { type: Boolean, default: false } },
  data() {
    return {
      usePage: true,
      checkedRow: [],
      mergeShipmentVisible: false,
      chooseTemplateOptions: {
        visible: false,
        shipmentCode: '',
        custCode: '',
        endCustCode: '',
        templateGroup: '',
        exportCheckUrl: '',
      },
    }
  },
  computed: {
    checkedCount() {
      if (!this.checkedRow) return 0
      return this.checkedRow.length
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .shipmentInfoPendingListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    mergeShipment() {
      if (!this.checkedRow || !this.checkedRow.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('tips_select_the_batch_to_consolidated_shipment') ||
            '请选择需要合并发运的批次',
          type: 'warning',
        })
        return
      }
      this.mergeShipmentVisible = true
    },
    onMergeShipmentDelete(e) {
      if (!e || !e.length) return

      this.checkedRow = this.checkedRow.filter((i) => {
        return e.findIndex((j) => i.orderBatchCode === j.orderBatchCode) < 0
      })

      this.$refs.main.clearCheckboxRows(e)
    },
    exportFile({ templateGroup }) {
      if (!this.checkedRow || !this.checkedRow.length) {
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_select_export_data'),
          type: 'warning',
        })
        return
      }

      const listShipmentBatchCode = this.checkedRow.map(
        (item) => item.shipmentBatchCode
      )

      this.chooseTemplateOptions = {
        visible: true,
        custCode: this.checkedRow[0].custCode,
        endCustCode: this.checkedRow[0].endCustCode,
        listShipmentBatchCode,
        templateGroup,
      }
    },
  },
}
</script>
<style scoped>
.print_btn_group {
  height: 110px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
